import { Link, Text } from '@ksyos/design-system';
import { useAbortableFetch } from '@frontend/utils/hooks/useAbortableFetch';
import { submitSamlForm } from '@frontend/utils/submitSamlForm';
import { RequestStatus } from '../../../common/enums/requestStatus';

type TherapielandSsoLinkProps = {
    children: React.ReactNode;
    dataToLinkToPatientContext?: {
        requesterOrganizationId: string;
        requesterPractitionerId: string;
        requestId: string;
        requestStatus: RequestStatus;
    };
    hasAccessToCounseling?: boolean;
    isToProgramOverview?: boolean;
};

export function TherapielandSsoLink(props: Readonly<TherapielandSsoLinkProps>) {
    const abortableFetch = useAbortableFetch();

    function isAllowedToSeeLink() {
        if (!props.dataToLinkToPatientContext) {
            return true;
        } else if (props.dataToLinkToPatientContext.requestStatus === RequestStatus.accepted) {
            return false;
        } else {
            return !!props.hasAccessToCounseling;
        }
    }

    function getLink() {
        if (props.dataToLinkToPatientContext?.requestId) {
            return `/api/therapieland/getSso?requestId=${props.dataToLinkToPatientContext.requestId}`;
        }

        if (props.isToProgramOverview) {
            return `/api/therapieland/getSso?isToProgramOverview=true`;
        }

        return '/api/therapieland/getSso';
    }

    async function handleClick() {
        const url = getLink();
        const { json: result } = await abortableFetch.fetchJson(url, 'GET');

        submitSamlForm({
            context: result.context,
            endpoint: result.endpoint,
        });
    }

    if (isAllowedToSeeLink()) {
        return (
            <Link
                onClick={async () => await handleClick()}
                variant="button"
            >
                {props.children}
            </Link>
        );
    } else {
        return <Text>{props.children}</Text>;
    }
}
